module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/image--business-circle-2-5ea6debc.png";